var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.value,
            direction: "rtl",
            size: "1100px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.value = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "acea-row row-center row-middle" },
            [
              _c(
                "div",
                { staticClass: "acea-row row-column row-middle flex-auto" },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.op === "edit" ? "活动真实用户" : "参与总人数")
                    ),
                  ]),
                  _c("el-link", { attrs: { type: "primary" } }, [
                    _vm._v(_vm._s(_vm.statistics.total) + "人"),
                  ]),
                ],
                1
              ),
              _vm._l(_vm.statistics.prizeList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "acea-row row-column row-middle flex-auto",
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(item.awardName) + "：" + _vm._s(item.prizeName)
                      ),
                    ]),
                    _vm.op === "edit"
                      ? _c("el-link", { attrs: { type: "primary" } }, [
                          _vm._v(
                            _vm._s(item.winnerCount) +
                              "人 / 共" +
                              _vm._s(item.totalPrizeNum) +
                              "份"
                          ),
                        ])
                      : _c("el-link", { attrs: { type: "primary" } }, [
                          _vm._v(
                            _vm._s(item.claimedCount) +
                              "人领取 领奖率：" +
                              _vm._s(item.claimRate) +
                              "%"
                          ),
                        ]),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c("search-page", {
            ref: "searchPage",
            attrs: {
              "column-count": 3,
              immediate: false,
              "form-data": _vm.formData,
              columns: _vm.columns,
              request: _vm.getList,
              formatter: _vm.formatter,
            },
            on: { "selection-change": _vm.handleSelectionChange },
            scopedSlots: _vm._u(
              [
                _vm.op === "edit"
                  ? {
                      key: "page-operation",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "acea-row" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    disabled: !_vm.multipleSelection.length,
                                  },
                                  on: { click: _vm.showPrizeModal },
                                },
                                [_vm._v("设置奖品")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                _vm.op === "edit"
                  ? {
                      key: "table-prepend",
                      fn: function () {
                        return [
                          _c("el-table-column", {
                            attrs: { type: "selection", width: "55" },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                {
                  key: "table-userInfo",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        { staticClass: "acea-row row-middle" },
                        [
                          _c("el-image", {
                            staticClass: "mr8",
                            attrs: {
                              src: row.userAvatar,
                              "preview-src-list": [row.userAvatar],
                            },
                          }),
                          _c("div", [_vm._v(_vm._s(row.userName || "-"))]),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "table-append",
                  fn: function () {
                    return [
                      _c("el-table-column", {
                        attrs: {
                          fixed: "right",
                          label: "操作",
                          align: "center",
                          width: "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                row.winsFlag
                                  ? _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.cancelPrize(row)
                                          },
                                        },
                                      },
                                      [_vm._v("取消中奖")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            title: "设置奖项",
            visible: _vm.box.show,
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.box, "show", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "奖项：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择奖项" },
                      model: {
                        value: _vm.box.prizeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.box, "prizeId", $$v)
                        },
                        expression: "box.prizeId",
                      },
                    },
                    _vm._l(_vm.prizeOptions, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.loading },
                  on: { click: _vm.setPrize },
                },
                [_vm._v("确定")]
              ),
              _c("el-button", { on: { click: _vm.closePrizeModal } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }